import { compose, branch, renderComponent, withProps } from 'recompose'
import { connect } from 'react-redux'
import moment from 'moment'

import {
  withInitialData,
  subscriptionSelect
} from '../components/hoc'
import IDSSoftwarePage from '../components/IDSSoftware'
import IDSSoftwareValidSubscription from '../components/IDSSoftware/WithValidSubscription'

const mapStateToProps = (state, ownProps) => {
  const idsProducts = state.products.list.length ? state.products.list : ownProps.products
  return {
    idsProducts: idsProducts.filter(item => item.product_type && item.product_type.key === 'IDS'),
    mdarsProducts: idsProducts.filter(item => item.product_type && item.product_type.key === 'MDARS'),
    softwareLinksMap: state.global.softwareLinks.byType
  }
}

export default compose(
  connect(mapStateToProps, null),
  withProps({
    title: 'common:ids-page',
    contentImage: ''
  }),
  withInitialData,
  subscriptionSelect,
  branch(
    ({ user }) => {
      if (user && user.ids_exp_date) {
        const expDate = moment(user.ids_exp_date)
        return moment().isBefore(expDate)
      }
    },
    renderComponent(IDSSoftwareValidSubscription)
  )
)(IDSSoftwarePage)




// WEBPACK FOOTER //
// ./pages/ids-software.js